<template>
	<div :class="height_limit ? 'parent' : 'parent-long'">
		<comments
		:joborderid="comment_joborderid"
		:show="show_comments"
        :view="view_comments"
		v-on:cancel="cancel_comment"
		v-on:save="save_comment"
		></comments>

		<div style="display:inline-block">
	        <div v-if="searchbar==true" class="search-field" style="float:left">
	            <button v-on:click="clear()" style="height:30px; width:40px;"><font-awesome-icon icon="times" /></button>
	    		<input v-model="search_term" @keydown.enter="setRouter(true)" @input="setRouter(false)"></input>
	    		<input v-if="useStatusSearch==true" v-model="status_search_term" @keydown.enter="setRouter(true)" @input="setRouter(false)"></input>
	            <button v-on:click="setRouter(true)" style="height:30px; width:40px;"><font-awesome-icon icon="search" /></button>

				<b v-if="use_limit==true">Limit</b>
				<input v-if="use_limit==true" v-model="limit" @keydown.enter="setRouter(true)" style="width:60px"></input>

				<b v-if="usePages==true">Page</b>
				<button v-if="usePages==true" v-on:click="addPage(-1)"><</button>
				<input v-if="usePages==true" v-model="page" @keydown.enter="setRouter(true)" style="width:60px"></input>
				<button v-if="usePages==true" v-on:click="addPage(1)">></button>
	        </div>

			<div v-if="searchbardate==true" class="search-field" style="float:left;">
				<input v-model="search_term" @change="setRouter(true)" type="date" style="height:30px;"></input>
				<button v-on:click="setDate(-1)" style="height:30px;">Prev</button>
				<button v-on:click="setDate(1)" style="height:30px;">Next</button>
				<b v-if="use_limit==true">Limit</b>
				<input v-if="use_limit==true" v-model="limit" @keydown.enter="setRouter(true)" style="width:60px"></input>
			</div>

			<filtr
				v-if="filter_options!=null && filter_options.length>0"
				style="float:left"
				:id=id
				:filter_options=filter_options
				v-on:input="setData"
			></filtr>
		</div>

		<div class="scroll" v-bind:style="navbar?'margin-bottom:50px':'margin-bottom:10px'">
			<table :key=update_key>
				<thead v-if="column_names.length>0">
					<tr v-if="collapseable==true">
						<th style="width:30px">
							<button v-if="collapsed==false" v-on:click="collapse()">-</button>
							<button v-else v-on:click="collapse()">+</button>
						</th>

						<th v-if="button_name!=null && perms.includes(button_perm)"
						v-bind:colspan="column_names.length"
						class="table-header">
							{{table_name}} Table <button class="copy-table" v-on:click="copyTable()">Copy Table</button>
						</th>
						<th v-else
						v-bind:colspan="column_names.length-1"
						class="table-header">
							{{table_name}} Table <button class="copy-table" v-on:click="copyTable()">Copy Table</button>
						</th>

					</tr>
					<tr v-else>
						<th v-if="button_name!=null && perms.includes(button_perm)"
						v-bind:colspan="column_names.length+1"
						class="table-header">
							{{table_name}} Table <button class="copy-table" v-on:click="copyTable()">Copy Table</button>
						</th>
						<th v-else
						v-bind:colspan="column_names.length"
						class="table-header">
							{{table_name}} Table <button class="copy-table" v-on:click="copyTable()">Copy Table</button>
						</th>
					</tr>

					<tr>
						<th v-if="button_name!=null && perms.includes(button_perm) && collapsed==false" style="width:30px">{{button_name}}</th>

						<th
						v-for="(name, index) in column_names"
						v-if="column_names[index]!='Color' && column_names[index]!='selectlink' && collapsed==false && !(hide_first_column==true && index == 0)">
							<div style="display:inline-block; white-space:nowrap;">
								{{name}}
								<button v-if="sort_value[index]==0" v-on:click="sort(index)"><font-awesome-icon icon="sort" /></button>
								<button v-else-if="sort_value[index]==1" v-on:click="sort(index)"><font-awesome-icon icon="sort-up" /></button>
								<button v-else-if="sort_value[index]==2" v-on:click="sort(index)"><font-awesome-icon icon="sort-down" /></button>
							</div>
						</th>
					</tr>
				</thead>
				<thead v-else-if="loading==true"><tr><th class="table-header">{{table_name}} Table Loading...</th></tr></thead>
                <thead v-else><tr><th class="table-header">{{table_name}} Table Empty</th></tr></thead>
				<tbody v-if="column_names.length>0 && collapsed==false">
					<tr v-for="(column, col) in column_data">
						<td v-if="button_name!=null && perms.includes(button_perm)" style="width:30px">
							<button v-on:click="select(col)">{{button_name}}</button>
						</td>

						<td
						v-for="(data, index) in column"
						v-if="column_names[index]!='Color' && column_names[index]!='selectlink' && !(hide_first_column==true && index == 0)"
						v-bind:id="'tableRow-'+col">
							<div v-if="column_names[index] == 'Document' && data!='null'">
								<document :id="index" :dir="'doc_'+data+'.jpg'" :doc_id="data" style="width:200px"></document>
							</div>
							<div v-else-if="column_names[index] == 'Side' && data!='null'" v-bind:id="'side-'+col">
								{{data}}
							</div>
							<div v-else-if="column_names[index] == 'CheckIn'">
								<button v-on:click="check(true, column_data[col][0])">Check In</button>
							</div>
							<div v-else-if="column_names[index] == 'CheckOut'">
								<button v-on:click="check(false, column_data[col][0])">Check Out</button>
							</div>
							<div style="width:200px" v-else-if="column_names[index] == 'AddComment'">
								<button style="width:60%" v-on:click="add_comment(col)">Add Comment</button>
								<button style="width:30%" v-on:click="view_comment(col)">View</button>
							</div>
							<div v-else-if="column_names[index] == 'Comments'" style="font-size:14px; overflow-y:scroll; max-height:60px; word-break:break-word;">
								{{data}}
							</div>
							<div v-else>
								<div v-if="custombuttons.includes(index)">
									<button v-on:click="selectCustom(col,index)" style="min-width:80px">{{data}}</button>
								</div>
								<div v-else style="white-space: pre-line;">{{ data }}</div>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
		</div>

		<div v-if="navbar==true" class="nav-bar">
			<div>
				<button v-for="(item, index) in nav_items" v-if="perms.includes(nav_item_perms[index])" v-on:click="button(item)">{{item}}</button>
			</div>
		</div>
	</div>
</template>

<script>
import api from '@/api'
import router from '@/router/index'
export default {
    props: {
		button_perm:String,
		searchbar:Boolean,
		filter_options:Array,
		navbar:Boolean,
		nav_items:Array,
		nav_item_perms:Array,
		button_name: '',
		term: '',
		termchange:false,
        id: Number,
		reroute: {
            type: String,
            required: false,
            default: ''
        },
		select_reroute: {
			type: Boolean,
			required: false,
			default: false
		},
		height_limit:{
			type:Boolean,
			required:false,
			default:true
		},
		collapseable:{
			type:Boolean,
			required:false,
			default:false
		},
		table_name:{
			type:String,
			required:false,
			default:""
		},
		use_limit:{
			type:Boolean,
			required:false,
			default:true
		},
		hide_first_column:{
			type:Boolean,
			required:false,
			default:false
		},
		searchbardate:{
			type:Boolean,
			required:false,
			default:false
		},
		custombuttons:{
			type:Array,
			required:false,
			default:[]
		},
		doAutoReload:{
			type:Boolean,
			required:false,
			default:false
		},
		usePages:{
			type:Boolean,
			required:false,
			default:false
		},
		separateSearch:{
			type:Boolean,
			required:false,
			default:false
		},
		useStatusSearch:{
			type:Boolean,
			required:false,
			default:false
		},
    },
	data() {
		return {
			collapsed:false,
			perms:[],
			search_term:'',
			status_search_term:'',
			limit:200,
			page:0,
			column_names: [],
			column_data:[],
			sort_value:[],
			loading:true,
			filtr:[],
			update_key:0,
            lastUpdate: 0,

			show_comments:false,
			view_comments:false,
			comment_joborderid:0,
			comment_index:0,
		}
	},
	async created () {
		this.perms = api.getPerms();
		if(this.separateSearch==false) this.search_term = this.term;

		var getLimit = parseInt(api.getCookie("limit_"+this.id))
		if(getLimit!=null && getLimit!=undefined && !isNaN(getLimit)) { this.limit = getLimit }

		var getPage = parseInt(api.getCookie("page_"+this.id))
		if(getPage!=null && getPage!=undefined && !isNaN(getPage)) { this.page = getPage }

		if(this.searchbardate==true&&this.term==undefined){
			this.setDate(0);
		}

		this.search(true)
		if(this.doAutoReload){
			this.autoReload()
		}
	},
	methods: {
		autoReload(){
			this.intervalID = setInterval(function(){
				this.search(true);
			}.bind(this), 5000);
		},
		setDate(move){
			var date;
			if(move==0){
				date = new Date();
			}else{
				date = new Date(this.search_term);
				date = new Date(date.setDate(2));
				date = new Date(date.setMonth(date.getMonth()+move));
			}

			var formatDate = date.getFullYear()+"-"+('00'+(date.getMonth()+1)).slice(-2)+"-"+('00'+date.getDate()).slice(-2);
			this.search_term = formatDate;

			if(move!=0){
				this.setRouter(true);
			}
		},
		collapse(){
			this.collapsed = !this.collapsed
		},
		async sort(index){
			this.sort_value.splice(index, 1, this.sort_value[index]+1);
			if(this.sort_value[index]>2)
				this.sort_value.splice(index, 1, 0);
			this.search(true)
		},
        async clear (){
            this.search_term = "";
            this.setRouter(true);
        },
		async setRouter(full){
			if(this.reroute!='' && this.separateSearch==false){
				if(this.search_term==''||this.search_term==undefined) {
					router.replace(this.reroute);
				}else {
					if(full){
						router.push(this.reroute+'?q='+this.search_term);
					}else{
						router.replace(this.reroute+'?q='+this.search_term);
					}
				}
			}

			this.search(full);
		},
		async search (full){
			var currentTerm = this.search_term;

			this.limit = parseInt(this.limit)
			this.page = parseInt(this.page)

			document.cookie="limit_"+this.id+"="+this.limit+";";
			document.cookie="page_"+this.id+"="+this.page+";";

			if(currentTerm!=this.search_term && this.search_term!=undefined){
				return;
			}else{
				this.loading=true;

				let timestamp = new Date().getTime()

				api.postData(
	                {
	                    type:"search",
	                    data:{
							pageid:this.id,
							fullsearch:full,
							limit:this.limit,
							data:[
		                        this.search_term,
								this.status_search_term
		                    ],
							term:this.term,
							sort:this.sort_value,
							filter:this.filter_options,
							page:this.page,
						},
                        timestamp:timestamp,
	                }
	            ).then((res) => {
					if(res.data.timestamp > this.lastUpdate){
                        this.lastUpdate = res.data.timestamp

						this.update_key++;
						this.clearColors()

						if(res.data.data!=null && res.data.data.column_data!=null){
				            this.column_names = res.data.data.column_names;
							this.column_data = res.data.data.column_data;
                            
							this.$emit('search', this.column_data);
							if(this.sort_value.length==0){
								for(let i = 0;i<res.data.data.column_names.length;i++) {
									this.sort_value[i] = 0;
								}
							}
						}

						if(full){
							api.setWOColors()
						}
						this.setColors()
                        
                        if (res.data.getAdditionalData==true) {
                            this.getAdditionalData()
                        }
					}
		        }).finally((res)=>{
					this.loading=false;
				});
			}
		},
        async getAdditionalData() {
            const batchSize = 20;
            
            for (let i = 0; i < this.column_data.length; i += batchSize) {
                const batch = this.column_data.slice(i, i + batchSize);
                const batchPromises = batch.map(async (columnData, batchIndex) => {
                    const actualIndex = i + batchIndex;
                    try {
                        const res = await api.postData({
                            type: "search",
                            data: {
                                pageid: this.id,
                                getAdditionalData: true,
                                data: [
                                    this.search_term,
                                    this.status_search_term
                                ],
                                columndata: columnData,
                                term: this.term,
                            }
                        });
                        const columnName = res.data.additionalDataColumn;
                        this.column_data[actualIndex][columnName] = res.data.data;
                    } catch (error) {
                        console.error(`Error loading data for column ${actualIndex}:`, error);
                    }
                });
                
                await Promise.all(batchPromises);
                this.update_key++;
            }
        },
		async clearColors(){
			if(this.column_names.includes('Side')){
				let position = this.column_names.indexOf('Side')
				for(let i = 0; i<this.column_data.length;i++){

					var element = document.getElementById('side-'+i).parentElement
					element.removeAttribute('style');
				}
			}

			if(this.column_names.includes('Color')){
				let position = this.column_names.indexOf('Color')
				for(let i = 0; i<this.column_data.length;i++){

					var row = document.getElementById('tableRow-'+i)
					row.removeAttribute('style');
				}
			}
		},
		async setColors(){
			let stateCheck = setInterval(() => {
				if (document.getElementById("tableRow-0")!=null) {
					clearInterval(stateCheck);

					if(this.column_names.includes('Side')){
						let position = this.column_names.indexOf('Side')
						for(let i = 0; i<this.column_data.length;i++){
							if(this.column_data[i][position]=="Port"){

								var element = document.getElementById('side-'+i).parentElement
								var style = 'background-color:#ffb5b5;';
								element.setAttribute('style', style);
							}
							else if(this.column_data[i][position]=="Starboard"){

								var element = document.getElementById('side-'+i).parentElement
								var style = 'background-color:#a5ffa5;';
								element.setAttribute('style', style);
							}
						}
					}

					if(this.column_names.includes('Color')){
						let position = this.column_names.indexOf('Color')
						for(let i = 0; i<this.column_data.length;i++){
							if(this.column_data[i][position]!=null){

								var color = this.column_data[i][position]
								var row = document.getElementById('tableRow-'+i)
								var style = 'background-color: #'+color+';';
								row.setAttribute('style', style);
							}
						}
					}
				}
			}, 100);
		},
        async select (index){
			var linkId = -1
			for(var i = 0;i<this.column_names.length;i++){
				if(this.column_names[i]=='selectlink'){
					linkId = i
				}
			}

			if(linkId!=-1){
				//console.log(this.column_data[index][linkId])
				window.location.href = this.column_data[index][linkId]
			}else{
				api.postData(
					{
						type:"select",
						data:{
							pageid:this.id,
							term:this.search_term,
							firstcolumn:this.column_names[0]
						}
					}
				).then((res) => {
					if(res.data.data.to!=null && this.select_reroute==true){
						router.push('/'+res.data.data.to+'?q='+this.column_data[index][res.data.data.select]);
						router.go(0)
					}
				})
			}

			this.$emit('select', this.column_data[index], this.search_term);
        },
		async selectCustom (col,index){
			this.$emit('selectCustom', this.column_data[col],index,this.search_term);
		},
		async button (name){
            this.$emit('button', name);

			if(name=="Cancel"){
				this.$emit('select', '');
			}

			api.postData(
				{
					type:"button",
					data:{
						pageid:this.id,
						buttonname:name,
					}
				}
			).then((res) => {
				if(res.data.data.to!=null) {
					if(res.data.data.useterm) {
						router.push('/'+res.data.data.to+'?q='+this.search_term);
					} else {
						router.push('/'+res.data.data.to);
					}
				}
			});
		},
		async copyTable(){
			var copyText = ''

			for(let i = 0;i < this.column_names.length;i++){
				copyText += this.column_names[i] + '\t'
			}
			copyText+='\n'

			for(let i = 0;i < this.column_data.length;i++){
				for(let j = 0; j< this.column_data[i].length;j++){
					copyText += this.column_data[i][j] + '\t'
				}
				copyText+='\n'
			}

			var el = document.createElement('textarea');
		    el.value = copyText;
		    document.body.appendChild(el);
		    el.select();
			el.setSelectionRange(0, copyText.length);
		    document.execCommand('copy');
		    document.body.removeChild(el);
			alert("copied to clipboard")
		},
		setData(filtr, update){
			this.filtr = filtr
			if(update){
				this.search(true)
			}
		},
		addPage(amt){
			this.page+=amt*this.limit;
			if(this.page<0){
				this.page=0;
			}

			this.setRouter(true)
		},
		check(isIn, itemId){
			this.$emit('check', isIn, itemId);
		},
		async add_comment(index) {
			let jobordercol = 0;
			for(var i = 0;i<this.column_names.length;i++){
				if(this.column_names[i]=='WONumber'){
					jobordercol = i;
				}
			}

			this.comment_index = index;
			this.comment_joborderid = parseInt(this.column_data[index][jobordercol].substr(3,5));
            this.view_comments = false;
			this.show_comments = true;
		},
		async view_comment(index) {
			let jobordercol = 0;
			for(var i = 0;i<this.column_names.length;i++){
				if(this.column_names[i]=='WONumber'){
					jobordercol = i;
				}
			}

			this.comment_index = index;
			this.comment_joborderid = parseInt(this.column_data[index][jobordercol].substr(3,5));
            this.view_comments = true;
			this.show_comments = true;
		},
		async cancel_comment() {
			this.comment_index = 0;
			this.comment_joborderid = 0;
			this.show_comments = false;
		},
		async save_comment(comment) {
			for(var i = 0;i<this.column_names.length;i++){
				if(this.column_names[i]=='Comments'){
					this.column_data[this.comment_index][i] += ", "+comment;
				}
			}
		},
	},
	watch:{
		term(){
			if(this.separateSearch==false) this.search_term = this.term;
			if(this.termchange==true){
				this.search(true);
			}
		},
	}
}
</script>



// WEBPACK FOOTER //
// src/layouts/layout_1.vue